import React, { useContext, useState } from "react";
import { Form, Input, Modal, TreeSelect } from "antd";
import Swal from "sweetalert2";
import useGEService from "../../../../services/useGE.service";
import { courseContext } from "../../../../pages/curriculum/curriculumDetail";
import courseService from "../../../../services/course.service";

const CreateCourse = () => {
  const { curri } = useContext<any>(courseContext);
  const { TreeNode } = TreeSelect;
  const [visible, setVisible] = useState(false);
  const [category, setCategory] = useState([]);

  const handleCancel = () => {
    setVisible(false);
  };
  const [form] = Form.useForm();
  const showModal = () => {
    setVisible(true);
    getCategory();
  };

  const onFinish = async (values: any) => {
    const data = {
      category: values.categoryForm,
      name: values.name,
      cradit: values.cradit,
      courseCode: values.courseCode,
      owner: curri?.id,
    };

    await courseService
      .cretateCourse(data)
      .then(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "บันทึกสำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          handleCancel();
          window.location.reload();
        });
      })
      .catch((error) => {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "มีความผิดพลาดบางอย่าง",
          showConfirmButton: false,
          timer: 1500,
        });
      });
  };

  const getCategory = async () => {
    useGEService.getCategory(curri.UseGE).then((res) => {
      // console.log(res.data);
      setCategory(res.data);
    });
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-success text-white"
        onClick={showModal}
      >
        <i className="bi bi-folder-plus"></i> เพิ่ม
      </button>

      <Modal
        visible={visible}
        title="เพิ่มรายวิชาใหม่"
        onCancel={handleCancel}
        width={768}
        footer={[
          <button
            type="submit"
            className="btn btn-primary"
            onClick={form.submit}
          >
            เพิ่มรายวิชา
          </button>,
          <button
            type="reset"
            className="btn btn-warning ms-1"
            onClick={() => form.resetFields()}
          >
            รีเซ็ต
          </button>,

          <button
            type="button"
            className="btn btn-danger ms-1"
            onClick={handleCancel}
          >
            Close
          </button>,
        ]}
      >
        <Form
          name="dynamic_form_nest_item"
          onFinish={onFinish}
          autoComplete="off"
          form={form}
          initialValues={{}}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 18 }}
        >
          <Form.Item
            name={"categoryForm"}
            label="หมวดหมู่"
            rules={[
              {
                required: true,
                message: "กรุณาเลือกหมวดหมู่ด้วยครับ",
              },
            ]}
          >
            <TreeSelect
              showSearch
              style={{ width: "100%" }}
              dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
              placeholder="เลือกหมวดหมู่"
              allowClear
              treeDefaultExpandAll
            >
              {/* {console.log(category)} */}
              {category.map((i: any) => {
                const aa = i.code.toString();

                if (aa.substring(1) === "000") {
                  return (
                    <TreeNode key={i.id} value={i.id} title={i.name}>
                      {category.map((j: any) => {
                        //เลือกเฉพาะ j ที่ตัวอักษรแรก == i.code ตัวแรก
                        const bb = j.code.toString();

                        if (aa.substring(0, 1) === bb.substring(0, 1)) {
                          if (
                            bb.substring(2) === "00" &&
                            bb.substring(1, 2) !== "0"
                          ) {
                            return (
                              <TreeNode key={j.id} value={j.id} title={j.name}>
                                {category.map((k: any) => {
                                  const cc = k.code.toString();
                                  if (
                                    aa.substring(0, 1) === cc.substring(0, 1) &&
                                    bb.substring(1, 2) === cc.substring(1, 2)
                                  ) {
                                    if (
                                      cc.substring(3) === "0" &&
                                      cc.substring(2, 3) !== "0"
                                    ) {
                                      return (
                                        <TreeNode
                                          key={k.id}
                                          value={k.id}
                                          title={k.name}
                                        ></TreeNode>
                                      );
                                    }
                                  }
                                  // ชั้น k: เติม return null ตรงนี้เพื่อให้มีค่าส่งกลับเสมอ
                                  return null;
                                })}
                              </TreeNode>
                            );
                          }
                        }
                        return null;
                      })}
                    </TreeNode>
                  );
                }
                return null;
              })}
            </TreeSelect>
          </Form.Item>

          <Form.Item
            name={"courseCode"}
            label="รหัสวิชา"
            rules={[
              {
                required: true,
                message: "กรุณาระบุรหัสวิชากด้วยครับ",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name={"name"}
            label="ชื่อวิชา"
            rules={[
              {
                required: true,
                message: "กรุณาชื่อวิชากด้วยครับ",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={"cradit"}
            label="หน่วยกิต"
            rules={[
              {
                required: true,
                message: "กรุณาระบุหน่วยกิตด้วยครับ",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CreateCourse;
